import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Chat = ({
  size,
  type,
  theme,
  className,
  dataTestId = "chat-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1665 3.33313C15.1665 2.22856 14.2711 1.33313 13.1665 1.33313L2.83317 1.33314C1.7286 1.33314 0.833166 2.22856 0.833166 3.33313V14.9998C0.833166 15.2655 0.990892 15.5058 1.23463 15.6114C1.47836 15.7171 1.76158 15.668 1.9555 15.4864L4.81879 12.8054L13.1665 12.8053C14.2711 12.8053 15.1665 11.9099 15.1665 10.8053V3.33313ZM13.1665 2.66646C13.5347 2.66646 13.8332 2.96494 13.8332 3.33313V10.8053C13.8332 11.1735 13.5347 11.472 13.1665 11.472L4.55539 11.472C4.38615 11.472 4.22325 11.5364 4.09972 11.6521L2.1665 13.4623V3.33313C2.1665 2.96495 2.46497 2.66647 2.83317 2.66647L13.1665 2.66646Z"
    />
  </SVGIcon>
);
